export const rootPath = '/';
export const homePath = '/home';
export const noAccessPath = '/no-access';
export const noInstallationPath = '/no-installation';
export const betaOfferingDeprecationPath = '/beta-offering-ended';
export const migrateFromBetaPath = '/migrate-from-beta';
export const overviewPath = '/overview';
export const yourUsagePath = '/your-usage';
export const orgUsagePath = '/usage';
export const dashboardPath = '/dashboard';
export const invitePath = '/invite';
export const scmSetupWizardPath = '/setup';
export const siteSettingsPath = '/site-settings';
export const settingsPath = '/settings';
export const userSettingsPath = '/my-settings';
export const settingsCodeReviewerPath = '/code-reviewer';
export const settingsCodeReviewerGithubPath = '/code-reviewer/github';
export const settingsCodeReviewerGithubReposSettingsPath =
	'/code-reviewer/github/organisations/:orgId';
export const settingsCodeReviewerGithubRepoSettingsPath =
	'/code-reviewer/github/organisations/:orgId/repositories/:repoName';
export const settingsRovoDevCLIPath = '/rovo-dev-cli';
export const upgradeRequestPath = '/upgrade-request';
export const boysenberryDashboardPath = '/sessions';
export const boysenberryDashboardLegacyPath = '/flow/dashboard';
export const boysenberryFlowPath = '/flow/s/:flowId';
export const boysenberryCodePagePath = '/flow/s/:flowId/code';
export const environmentSettingsPath = '/environment-settings/:encodedRepoUrl';
export const githubOauthRedirectPath = '/github-oauth-redirect';
export const creditRequestPath = '/request-rovo-credits';
export const reviewerPath = '/reviewer';
export const reviewerRepositoriesPath = '/reviewer/repositories';
export const standardsPath = '/standards';
export const standardsNewPath = '/standards/new';
export const standardsDetailPath = '/standards/:standardId';
export const autoDevDashboardPath = '/autodev';
export const autoDevRefinePath = '/autodev/refine';
export const autoDevRefineIssuePath = '/autodev/refine/:issueKey';
export const autoDevBacklogScansPath = '/autodev/backlog-scans';
export const autoDevWorkstreamsPath = autoDevBacklogScansPath;
export const autoDevSettingsPath = '/autodev/settings';
export const autoDevSettingsSkillsRepositoryPath = '/autodev/settings/skill-repositories';
export const autoDevSettingsSharedSpacesPath = '/autodev/settings/shared-spaces';
export const autoDevAssemblyLinePath = '/autodev/dashboard/:workstreamId';
/**
 * Backlog scan dashboard with an explicit tab segment for deep-linking.
 * The tab param is constrained to the known non-default tab slugs so it does not
 * collide with the `/settings` sub-routes. The default "Needs Attention" tab is
 * served by the bare {@link autoDevAssemblyLinePath} (no segment).
 */
export const autoDevAssemblyLineTabPath =
	'/autodev/dashboard/:workstreamId/:tab(insights|all-work-items)';
/** Exact URL; redirects to the first per-workstream settings sub-page. */
export const autoDevAssemblyLineSettingsPath = '/autodev/dashboard/:workstreamId/settings';
/** Sub-pages under per-workstream settings (Details, Access, Projects, etc.). */
export const autoDevAssemblyLineSettingsSectionPath =
	'/autodev/dashboard/:workstreamId/settings/:settingsSection';
/** This is the working route name for the DevAI (not finalised) */
export const devaiSetupWizardPath = '/setup-devai';

/** Page shown to non-admin users who have product access but not admin access. */
export const appAdminUnavailablePath = '/app-admin-unavailable';

/** SRE overview page (gated behind `devai_app_sre_enabled`). */
export const srePath = '/sre';
/** SRE installation setup wizard page (gated behind `devai_app_sre_enabled`). */
export const sreSetupPath = '/sre/setup';
/** SRE detailed usage page (gated behind `devai_app_sre_enabled`). */
export const sreDetailedUsagePath = '/sre/detailed-usage';

/**
 * URL slugs for the backlog scan dashboard tabs. The default "Needs Attention"
 * tab has no slug — it is served by the bare backlog scan URL.
 */
export const autoDevAssemblyLineTabSlugs = ['insights', 'all-work-items'] as const;
export type AutoDevAssemblyLineTabSlug = (typeof autoDevAssemblyLineTabSlugs)[number];

/** Build a concrete URL to the per-workstream backlog scan dashboard. */
export const getAutoDevAssemblyLineUrl = (workstreamId: string): string =>
	`/autodev/dashboard/${workstreamId}`;

/**
 * Build a concrete URL to a specific backlog scan dashboard tab. Passing the
 * default "Needs Attention" tab (no slug) returns the bare backlog scan URL.
 */
export const getAutoDevAssemblyLineTabUrl = (
	workstreamId: string,
	tab?: AutoDevAssemblyLineTabSlug,
): string =>
	tab ? `/autodev/dashboard/${workstreamId}/${tab}` : getAutoDevAssemblyLineUrl(workstreamId);

/** Build a concrete URL to the per-workstream settings landing page. */
export const getAutoDevAssemblyLineSettingsUrl = (workstreamId: string): string =>
	`/autodev/dashboard/${workstreamId}/settings`;
